/**
 * js/common/JSON.js が読み込まれている環境と読み込まれていない環境の JSON.stringify の出力の差異を吸収します。
 *
 * @param obj
 * @returns {string|*}
 */
export function toJSONString(obj) {
    if (typeof Object.toJSON === 'function') {
        return Object.toJSON(obj);
    }
    return JSON.stringify(obj);
}
